import { CustomThemeProps } from '@interfaces/Contexts';
import React from 'react';

export const CustomThemeContext = React.
    createContext<CustomThemeProps>({} as CustomThemeProps);
